module.exports = __webpack_public_path__ + "static/Bodegon--puntos-21b45bf91914864df2b94f9b3590103a.png";